import { Box, Container, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { IRootState } from '../../redux/types'
import EventCalendar from '../backoffice/events/ui/components/EventCalendar'
import CustomSnackBar from '../shared/components/CustomSnackBar'
import CoursesFeed from '../shared/components/frontoffice/CoursesFeed'
import NewsFeed from '../shared/components/frontoffice/NewsFeed'
import ResourcesFeed from '../shared/components/frontoffice/ResourcesFeed'
import MenuIcons, { IMenuIcons } from '../shared/components/icons/MenuIcons'
import useScreenWidth from '../shared/hooks/useScreenWidth'
import { ButtonWorld } from '../shared/styles/HomeStyles'
import ShowFirstStartVideo from './ShowFirstStartVideo'
import SliderClient from './sliders/ui/components/SliderClient'
import AccountBoxIcon from '@mui/icons-material/AccountBox';

type IMenu = {
  id: number
  name: string
  code: keyof IMenuIcons
  path: string
}

function Home() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const navigate = useNavigate()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { error: errorNovelties, msg: msgNovelties } = useSelector((state: IRootState) => state.novelty)
  const { error: errorCourse, msg: msgCourse } = useSelector((state: IRootState) => state.course)
  const { error: errorResource, msg: msgResource } = useSelector((state: IRootState) => state.resource)

  const existMenu = (menuCode: keyof IMenuIcons) => {
    return authUser.menus.some((menu: IMenu) => menu.code === menuCode)
  }

  return (
    <Box>
      <SliderClient />
      <Container maxWidth="xl" sx={theme => ({ [theme.breakpoints.down('sm')]: { paddingLeft: 0, paddingRight: 0 } })}>
        <Box width="100%" sx={theme => ({ [theme.breakpoints.down('sm')]: { display: 'none' } })} pt={2}>
          <Box
            display="flex"
            py={isMobile ? 3 : 4}
            px={isMobile ? 1 : 6}
            alignItems="center"
            gap={isMobile ? '16px' : '16px'}
            sx={{
              '& h6': {
                fontWeight: 500,
                whiteSpace: 'nowrap'
              }
            }}
          >
          <Box
            sx={{
              height: '1px',
              backgroundColor: 'grey.500',
              flexGrow: 1,
            }}
          />
          <Typography
            variant={isMobile ? 'subtitle1' : 'h6'}
            sx={{ mx: 2, whiteSpace: 'nowrap' }} // espacio horizontal
          >
            {t('meet-our-worlds')}
          </Typography>
          <Box
            sx={{
              height: '1px',
              backgroundColor: 'grey.500',
              flexGrow: 1,
            }}
          />
          </Box>
          <Box
            display="flex"
            pb={isMobile ? 1 : 4}
            px={isMobile ? 1 : 0}
            alignItems="center"
            justifyContent="center"
            gap={isMobile ? '16px' : '20px'}
            sx={theme => ({
              [theme.breakpoints.down('sm')]: { display: 'none' },
              [theme.breakpoints.down('xs')]: { flexDirection: 'column' }
            })}
          >
            {authUser.menus.map((menu: IMenu) => (
              <>
              <ButtonWorld
                key={menu.id}
                color="primary"
                variant="contained"
                onClick={() => {
                  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
                  navigate(`/${menu.path}`)
                }}
                className={authUser.menus.length <= 2 ? 'fixed' : ''}
              >
                <MenuIcons menuCode={menu.code} />
                <Typography variant={isMobile ? 'subtitle1' : 'h6'}>{t(menu.code)}</Typography>
              </ButtonWorld>

              </>
            ))}
          </Box>
        </Box>
        <Grid container spacing={isMobile ? 5 : 4} sx={theme => ({ width: '100%', [theme.breakpoints.up('sm')]: { marginTop: '-40px' } })}>
          <Grid xs={12} md={existMenu('events') ? 7 : 12} style={isMobile ? { paddingTop: 2, paddingBottom: 2 } : { paddingTop: 16 }}>
            <Grid container spacing={2}>
              <Grid xs={12} md={existMenu('events') ? 12 : 6}>
                <NewsFeed />
              </Grid>
              {existMenu('academy') && (
                <Grid xs={12} md={existMenu('events') ? 12 : 6}>
                  <CoursesFeed />
                </Grid>
              )}
              {existMenu('library') && (
                <Grid xs={12} md={existMenu('events') ? 12 : 6}>
                  <ResourcesFeed />
                </Grid>
              )}
            </Grid>
          </Grid>
          {existMenu('events') && (
            <Grid md={5} style={isMobile ? { paddingTop: 0 } : { paddingTop: 0 }}>
              <EventCalendar />
            </Grid>
          )}
        </Grid>
      </Container>

      {import.meta.env.VITE_NAME === 'PLEI' && <ShowFirstStartVideo />}

      <CustomSnackBar errors={[errorNovelties, errorCourse, errorResource]} msgs={[msgNovelties, msgCourse, msgResource]} />
      {/* <ScreenLoading loadings={[loadingNovelties, loadingCourse, loadingResource]} /> */}
    </Box>
  )
}

export default Home
